import { useResourceRoute } from 'json-api-hooks';
import React, { FC } from 'react';

import ActionsBar from '../../components/ActionsBar';
import { Section } from '../../components/App/typescript';
import Card from '../../components/Card';
import CardContent from '../../components/Card/CardContent';
import HeaderWithFloat from '../../components/HeaderWithFloat';
import Markdown from '../../components/Markdown';
import EventDropdownMenu from '../../dropdownMenus/EventDropdownMenu';
import { EventResource } from '../../models';

import EventDetails from './EventDetails';
import EventSignUpButton from './EventSignUpButton';

const EventCard: FC<{ item: EventResource }> = ({ item }) => {
  const route = useResourceRoute(item);

  return (
    <Card>
      <CardContent>
        {item && (
          <HeaderWithFloat float={<EventDropdownMenu event={item} />} link={route} title={item.attributes.name} />
        )}
        <EventDetails event={item} />
        <Markdown text={item?.attributes.description} />
      </CardContent>
      {GLOBALS.section === Section.Main && (
        <ActionsBar>
          <EventSignUpButton event={item} />
        </ActionsBar>
      )}
    </Card>
  );
};

export default EventCard;
